import React, { useEffect, useRef, useState } from 'react';

const hasObserver = () => typeof window !== 'undefined' && typeof window.IntersectionObserver === 'function';

/**
 * Renders its children only once this spot comes within `margin` of the
 * viewport (then keeps them). Used for below-the-fold product-page sections
 * so their code chunks and API calls stay out of the first load (perf PLAN
 * #4). `minHeight` reserves space until then, so the page does not jump.
 * Without IntersectionObserver the children render at once.
 */
const NearMount = ({ children, margin = '400px 0px', minHeight = 0 }) => {
  const ref = useRef(null);
  const [near, setNear] = useState(!hasObserver());

  useEffect(() => {
    const node = ref.current;
    if (near || !node || !hasObserver()) return undefined;
    const io = new window.IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        setNear(true);
        io.disconnect();
      }
    }, { rootMargin: margin });
    io.observe(node);
    return () => io.disconnect();
  }, [near, margin]);

  if (near) return children;
  return <div ref={ref} style={minHeight ? { minHeight } : undefined} data-testid="near-mount" aria-hidden="true" />;
};

export default NearMount;
